var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "10", height: "10", viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { y: "12.728", width: "18", height: "2.5", rx: "1.25", transform: "rotate(-45 0 12.728)", fill: "#fff" }),
    React.createElement("rect", { x: "12.728", y: "14.496", width: "18", height: "2.5", rx: "1.25", transform: "rotate(-135 12.728 14.496)", fill: "#fff" })
  );
});